module.exports = __webpack_public_path__ + "static/atom-green-bf2d0aa165068f84f05a963959c274a0.png";